import React, { useEffect, useState } from "react";
import {ChevronsUpDown, EllipsisVertical, PenSquare, Trash2} from "lucide-react";
import DeleteModal from "../Modal/DeleteModal";
import { can_visit, usPhoneFormat } from "../../helpers";
import EditUserInfoModal from "../Modal/EditUserInfoModal";
import Skeleton from "react-loading-skeleton";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function AllUsersDataTable(props) {
  const {
    allProviders = [],
    tableData = [],
    handleDeleteRecord = () => {},
    reloadData = () => {},
    reloadDataFilter = {},
    handleUpdatedUserInfo = () => {},
    dataLoading,
    setDataLoading = () => {},
    userRoles = [],
    updateLoader = false,
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {}
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [editUserModal, setEditUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [viewStatusOptions, setViewStatusOptions] = useState({});
  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);

  const getProviderNamesByIds = (linked_providers) => {
    return linked_providers.map(id => {
            const provider = allProviders.find(item => item.provider_id === id);
            return provider ? `<span class="docpro_badge docpro_badge_blue docpro_fs_12 ">${provider.first_name} ${provider.last_name}</span><br>` : "";
        })
        .filter(Boolean) // remove empty strings
        .join("");
  }
  
  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    setDataLoading(true);
    reloadData(filter_merge);
  };
  const handleCloseEditUserModal = () => {
    setEditUserModal(false);
    window.scrollTo(0, previousScrollPosition);
    setSelectedUser({});
  };

  const handleOpenEditUserModal = (user) => {
    setEditUserModal(true);
    setSelectedUser(user);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions({});
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDropdownClick = (index) => {
    setViewStatusOptions((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  return (
    <>
      <div className="docpro_table_responsive custom-scroll" style={{ minHeight: '200px' }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th>
                <div
                  onClick={() => { handleOrderChange("last_name"); }}
                  className={
                    orderBy === "last_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Last Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => { handleOrderChange("first_name"); }}
                  className={
                    orderBy === "first_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                  First Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => { handleOrderChange("email"); }}
                  className={
                    orderBy === "email" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Email <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => { handleOrderChange("user_name"); }}
                  className={
                    orderBy === "user_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Username <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>              
              <th>Roles</th>
              <th>Linked Providers</th>
              <th className="docpro_text_center"></th>
            </tr>
          </thead>
          <tbody>
          {!dataLoading ? (
            tableData.length > 0 ? (
              tableData?.map((item, index) => (
                <tr key={index}>
                  <td >{item?.last_name}</td>
                  <td>{item?.first_name}</td>
                  <td>{item?.email}</td>
                  <td>{item?.user_name}</td>
                  {/* <td>{usPhoneFormat(item?.contact)}</td> */}
                  <td>
                    {item?.roles?.filter(name => userRoles.includes(name)).map((name, index) => (
                      <span key={index} className="docpro_badge docpro_badge_olive">
                        {name}
                      </span>
                    ))}
                  </td>
                  <td>                    
                    <div dangerouslySetInnerHTML={{ __html: getProviderNamesByIds(item?.linked_providers || []) }} />
                  </td>
                  <td className="docpro_text_center">
                    {(can_visit("settings_users_all_users_edit") || can_visit("settings_users_all_users_delete")) && (
                      <div className="docpro_icon_btns">
                        <div className="dropdown-container relative">
                          <button className="docpro_icon_btn" onClick={() => handleDropdownClick(index)}>
                            <EllipsisVertical width={18} height={18} />
                          </button>
                          {viewStatusOptions[index] && (
                            <div className={`docpro_button_toggle_options ${index > 1 && 'top_position'}`}>
                              {(can_visit("settings") && can_visit("settings_users") && can_visit("settings_users_all_users_edit")) && (
                                <button
                                  className="docpro_icon_btn docpro_dropdown_button"
                                  onClick={() => {
                                    handleOpenEditUserModal(item);
                                  }}
                                >
                                  <PenSquare width={18} height={18} />
                                  <span>Edit User</span>
                                </button>
                              )}
                              {(can_visit("settings") && can_visit("settings_users") && can_visit("settings_users_all_users_delete")) && (
                                <button
                                  className="docpro_icon_btn docpro_dropdown_button docpro_icon_btn_red"
                                  onClick={() => {
                                    setDeleteRecord(item);
                                    setActiveDeleteModal(true);
                                    setPreviousScrollPosition(window.scrollY);
                                    window.scrollTo(0, 0);
                                  }}
                                >
                                  <Trash2 width={18} height={18} />
                                  <span>Delete</span>
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </td>
                  
                </tr>
              ))
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "200px" }} colSpan="7">
                  No data available
                </td>
              </tr>
            )
          ) : (
            Array.from({ length: 8 }).map((_, index) => (
              <tr key={index} style={{ height: '50px' }}>
                <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                <td> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                <td> <Skeleton width={`${5.5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                <td className="text-right"> <span className="mr-4 pr-2"><Skeleton width="3rem" borderRadius="8px"></Skeleton></span> </td>
              </tr>
            ))
          )}
          </tbody>
        </table>
      </div>
      {editUserModal && (
        <EditUserInfoModal
          allProviders={allProviders}
          onClose={handleCloseEditUserModal}
          userData={selectedUser}
          handleDelete={() => {
            setEditUserModal(false);
            handleDeleteRecord(selectedUser.id);
          }}
          handleUpdatedInvitedUserInfo={handleUpdatedUserInfo}
          userRoles={userRoles}
          updateLoader={updateLoader}
        />
      )}

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name={deleteRecord?.last_name + ' ' + deleteRecord?.first_name}
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
    </>
  );
}
